/* eslint-disable */
export const colorMap = {
    'Appaloosa': 'Ap',
    'Appaloosa/Cream': 'Ap/Cr',
    'Bay': 'B',
    'Bay/Appaloosa': 'B/Ap',
    'Bay/Black': 'B/Bl',
    'Bay or Brown': 'B/Br',
    'Bay/Chesnut': 'B/Ch',
    'Bay/Dun': 'B/D',
    'Bay/Grey': 'B/Gr',
    'Bay/Roan': 'Bl/Ro',
    'Black': 'BL',
    'Black/Bay': 'Bl/B',
    'Black/Brown': 'Bl/Br',
    'Black/Grey': 'Bl/Gr',
    'Black/Roan': 'Bl/Ro',
    'Bay Overo': 'BO',
    'Brown': 'Br',
    'Brown/Bay': 'Br/B',
    'Brown/Black': 'Br/Bl',
    'Brown/Brown': 'Br/Br',
    'Brown/Chesnut': 'Br/Ch',
    'Brown/Grey': 'Br/Gr',
    'Brown/Roan': 'Br/Ro',
    'Buckskin': 'Bu',
    'Black Overo': 'BV',
    'Black Overo/Black': 'BV/Bl',
    'Chesnut': 'Ch',
    'Chesnut/Bay': 'Ch/B',
    'Chesnut/Black': 'Ch/Bl',
    'Chesnut/Brown': 'Ch/Br',
    'Chesnut/Chesnut': 'Ch/Ch',
    'Chesnut/Dun': 'Ch/D',
    'Chesnut/Grey': 'Ch/Gr',
    'Chesnut/Roan': 'Ch/Ro',
    'Cremello': 'CM',
    'Chesnut Overo': 'CO',
    'Cream': 'Cr',
    'Dun': 'D',
    'Dun/Bay': 'D/B',
    'Dun/Chesnut': 'D/Ch',
    'Dun/Grey': 'D/Gr',
    'Grey': 'Gr',
    'Grey/Bay': 'Gr/B',
    'Grey/Black': 'Gr/Bl',
    'Grey/Brown': 'Gr/Br',
    'Grey/Chesnut': 'Gr/Ch',
    'Grey/Grey': 'Gr/Gr',
    'Grey/Roan': 'Gr/Ro',
    'Grey/White': 'Gr/Wh',
    'Leopard': 'L',
    'Leopard/Bay': 'L/B',
    'Overo': 'Ov',
    'Palomino': 'Pa',
    'Painted': 'PT',
    'Piebald': 'P',
    'Skewbald': 'Sk',
    'Skewbald/Appaloosa': 'Sk/Ap',
    'Skewbald/Roan': 'Sk/Ro',
    'Skewbald/Tobiano': 'Sk/To',
    'Spotted': 'Sp',
    'Roan': 'Ro',
    'Roan/Brown': 'Ro/Br',
    'Roan/Chesnut': 'Ro/Ch',
    'Roan/Grey': 'Ro/Gr',
    'Tobiano': 'To',
    'Unknown': 'U',
    'White': 'Wh',
};

export const raceDistanceMap = {
    '5f': '5f',
    '6f': '6f',
    '7f': '7f',
    '8f': '1m',
    '9f': '1m1f',
    '10f': '1m2f',
    '11f': '1m3f',
    '12f': '1m4f',
    '13f': '1m5f',
    '14f': '1m6f',
    '15f': '1m7f',
    '16f': '2m',
    '17f': '2m1f',
    '18f': '2m2f',
    '19f': '2m3f',
    '20f': '2m4f',
    '21f': '2m5f',
    '22f': '2m6f',
    '23f': '2m7f',
    '24f': '3m',
    '25f': '3m1f',
    '26f': '3m2f',
    '27f': '3m3f',
    '28f': '3m4f',
    '29f': '3m5f',
    '30f': '3m6f',
    '31f': '3m7f',
    '32f': '4m',
    '33f': '4m1f',
    '34f': '4m2f',
    '35f': '4m3f',
    '36f': '4m4f',
};


// WEBPACK FOOTER //
// ./src/js/horse/recentStakesPerformers/components/utilsMap.js